<template>
  <div class="under-development-container d-flex align-items-center justify-content-center min-vh-100 bg-light">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-8 col-lg-6">
          <div class="card border-0 shadow-lg rounded-4 overflow-hidden">
            <div class="card-header bg-danger text-white py-4">
              <div class="d-flex align-items-center justify-content-center">
                <i class="bi bi-tools fs-1 me-3"></i>
                <h2 class="mb-0 fw-bold">Under Construction</h2>
              </div>
            </div>
            <div class="card-body p-5 text-center">
              <div class="dev-icon mb-4">
                <i class="bi bi-hammer text-danger" style="font-size: 3rem;"></i>
                <i class="bi bi-gear-fill text-danger mx-4" style="font-size: 3.5rem;"></i>
                <i class="bi bi-wrench text-danger" style="font-size: 3rem;"></i>
              </div>
              <h3 class="fw-bold mb-3">This page is currently under development</h3>
              <p class="text-muted mb-4">
                We're working hard to bring you this feature. Please check back soon!
              </p>
              <div class="progress mb-4" style="height: 8px;">
                <div 
                  class="progress-bar progress-bar-striped progress-bar-animated bg-danger" 
                  role="progressbar" 
                  :style="{ width: progress + '%' }" 
                  :aria-valuenow="progress" 
                  aria-valuemin="0" 
                  aria-valuemax="100"
                ></div>
              </div>
              <button 
                @click="refreshPage" 
                class="btn btn-outline-danger rounded-pill px-4 py-2"
              >
                <i class="bi bi-arrow-clockwise me-2"></i>Check Again
              </button>
            </div>
            <div class="card-footer bg-light text-center py-3">
              <small class="text-muted">
                <i class="bi bi-info-circle me-1"></i> Powered By: <b> <a href="https://exodoustechsolutions.com">{{ estimatedCompletion }}</a></b>
              </small>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
    import {ref} from "vue"
    const progress = ref(65);
    const estimatedCompletion = ref('Exodous I.T. Solutions');
    const refreshPage = ()=>{
window.location.reload();
    }

  
</script>

<style scoped>
a{
    text-decoration: none;
    color: #000;
}
.under-development-container {
  background: linear-gradient(135deg, #fff5f5 0%, #ffecec 100%);
}

.card {
  border: none;
  overflow: hidden;
}

.dev-icon i {
  transition: transform 0.3s ease;
}

.dev-icon i:hover {
  transform: rotate(15deg);
}

.progress {
  border-radius: 4px;
  background-color: #ffd6d6;
}
</style>